<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="card center p-4">
          <h6>
            Bem vindo, <b>administrador</b>! Selecione uma das opções abaixo.
          </h6>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6 mb-4">
        <div
          class="card card-shadow h-100 center"
          @click="$router.push('/admin/empresas')"
        >
          <a href="" title="Verificar franquias">
            <div class="waves-effect" style="padding: 30px">
              <i class="fa-solid fa-building fa-5x mb-3"></i>
              <h5 class="mt-4">Empresas</h5>
            </div>
          </a>
          <p>Veja seus clientes.</p>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 mb-4">
        <div
          class="card card-shadow h-100 center"
          @click="$router.push('/admin/contadores')"
        >
          <a href="" title="Verificar contadores">
            <div class="waves-effect" style="padding: 30px">
              <i class="fa-solid fa-users-line fa-5x mb-3"></i>
              <h5 class="mt-4">Contadores</h5>
            </div>
          </a>
          <p>Veja e controle o acesso de seus contadores.</p>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 mb-4">
        <div
          class="card card-shadow h-100 center"
          @click="$router.push('/admin/nfse/configs')"
        >
          <a href="" title="Configurações NFSe">
            <div class="waves-effect" style="padding: 30px">
              <i class="fa-solid fa-file-invoice fa-5x mb-3"></i>
              <h5 class="mt-4">NFSe</h5>
            </div>
          </a>
          <p>Gerencie as configurações NFSe das empresas.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "admin-homepage",
};
</script>
<style scoped>
a {
  text-decoration: none;
}
</style>
